/* eslint-disable no-mixed-operators */
/* eslint-disable max-len */
import { degrees2radians } from '../../functions';
import { Vertex3 } from '../vertex-3.class';

// eslint-disable-next-line max-params
export const rotate3AxisCfn = (point: Vertex3, origin: Vertex3, angle: number, axis: string): Vertex3 => {
	if (angle === 0) return point;

	// Convert the angle from degrees to radians
	const rad = degrees2radians(angle);
	// Subtract the origin coordinates from the point coordinates
	const dx = point.x - origin.x;
	const dy = point.y - origin.y;
	const dz = point.z - origin.z;
	// Apply the rotation formula based on the axis to get the new coordinates.
	// No rounding here — rotation is pure math. Rounding at this level introduces
	// 1/16" errors for non-cardinal angles (e.g. 45° corner island panels).
	// Callers that need display-friendly values should round at the presentation layer.
	if (axis === 'x') {
		point.x = dx + origin.x;
		point.y = (dz * Math.sin(rad)) + (dy * Math.cos(rad)) + origin.y;
		point.z = (dz * Math.cos(rad)) - (dy * Math.sin(rad)) + origin.z;
	} else if (axis === 'y') {
		point.x = (dx * Math.cos(rad)) - (dz * Math.sin(rad)) + origin.x;
		point.y = dy + origin.y;
		point.z = (dx * Math.sin(rad)) + (dz * Math.cos(rad)) + origin.z;
	} else if (axis === 'z') {
		point.x = (dy * Math.sin(rad)) + (dx * Math.cos(rad)) + origin.x;
		point.y = (dy * Math.cos(rad)) - (dx * Math.sin(rad)) + origin.y;
		point.z = dz + origin.z;
	}

	return point;
}
